import React from 'react';
import PropTypes from 'prop-types';

import { View } from '../../../../shared/components';
import Section from '../../../../shared/components/Section';
import Text from '../../../../shared/components/Text';

import { styleUtils } from '../../../../shared/utils';
import { COLORS } from '../../../../shared/design/tokens';

import styles from './styles';
import FORMAT_PATTERNS from "../../../../shared/constants/format";

const { style } = styleUtils;

const MainSection = style(Section);
const Container = style(View, styles.container);
const TitleContainer = style(View, styles.titleContainer);
const Title = style(Text);
const Divider = style(View, styles.divider);

const SectionContainer = style(View);
const SectionTitle = style(Text, styles.sectionTitle);
const SectionRow = style(View, styles.sectionRow);
const SumSectionContainer = style(View, styles.sumSectionContainer);
const TotalSectionContainer = style(View, styles.totalSectionContainer);

const TotalContainer = style(View);
const TotalValueContainer = style(View);
const LabelContainer = style(View, styles.labelContainer);
const Label = style(Text, styles.label);
const ValueContainer = style(View, styles.valueContainer);
const Value = style(Text, styles.value);
const MultiLineValue = style(Text, styles.value);

const OrderSummaryItem = ({ title, data }) => (
  <SectionContainer>
    <SectionTitle weight="900">{title}</SectionTitle>
    {data && data.map(
      (
        {
          type,
          removeTopPadding = false,
          label,
          value,
          values,
          multiLine = false
        },
        sumIndex
      ) => {
        if (type === 'bold')
          return (
            <SumSectionContainer
              removeTopPadding={removeTopPadding}
              key={`bold_${sumIndex}`}
            >
              {values.map((props, i) => (
                <SectionRow key={props.label || `label-section-${i}`}>
                  <LabelContainer key={props.label}>
                    <Value>{props.label}</Value>
                  </LabelContainer>
                  <ValueContainer multiLine={multiLine}>
                    <Value>{props.value}</Value>
                    {props.per && <Value size="placeholder">{props.per}</Value>}
                  </ValueContainer>
                </SectionRow>
              ))}
            </SumSectionContainer>
          );
        else if (!label) return null;
        return (
          <SectionRow key={label}>
            <LabelContainer>
              <Label>{label}</Label>
            </LabelContainer>
            <ValueContainer multiLine={multiLine}>
              {multiLine ? (
                value
                  .split(',')
                  .map(val => <MultiLineValue key={val}>{val}</MultiLineValue>)
              ) : (
                <Value>{value}</Value>
              )}
            </ValueContainer>
          </SectionRow>
        );
      }
    )}
  </SectionContainer>
);

const Total = ({ total, totalPer, t }) => (
  <TotalSectionContainer>
    <SectionRow>
      <TotalContainer>
        <Value weight="900">{t('total')}</Value>
      </TotalContainer>
      <TotalValueContainer>
        <Value weight="900" format={FORMAT_PATTERNS.currency}>{total}</Value>
        {totalPer && total > 0 ? <Value size="placeholder">{totalPer}</Value> : null}
      </TotalValueContainer>
    </SectionRow>
  </TotalSectionContainer>
);

const OrderSummary = ({ t, show, data, total, totalPer }) =>  show ? (
    <MainSection height="0%">
      <Container>
        <TitleContainer>
          <Title size="large" color={COLORS.TEXT.BLACK}>
            {t('title')}
          </Title>
        </TitleContainer>
        <Divider />
        {data && Object.keys(data).map(step => {
          const stepData = data[step];
          return stepData && stepData.map(({ type, title, data:itemData}) => itemData && (
            <OrderSummaryItem
              key={`${step}_${title}`}
              title={title}
              data={itemData}
            />
          ));
        })}
        <Divider />
        <Total total={total} t={t} totalPer={totalPer} />
      </Container>
    </MainSection>
  ) : null;


OrderSummary.propTypes = {
  show: PropTypes.bool.isRequired,
  data: PropTypes.object,
  total: PropTypes.number
};

OrderSummary.defaultProps = {
  data: {}
};

export default OrderSummary;
